import { axiosInstance } from "../../../axios/axiosInstance";

const GET_ALL_OFFER = `organization/offers/get-all-organization-offers`;
const CREATE_OFFER = `organization/offers/add-offer`;
const GET_OFFER_BY_ID = `organization/offers/get-offer-by-id`;
const EDIT_OFFER = `organization/offers/update-offer`;
const DELETE_OFFER = `organization/offers/update-status`;
const API_PURCHASE_OFFER_SPONSORSHIP_URL = "organization/offers/purchase-offer-sponsership"
const API_PURCHASE_PACKAGE_SPONSORSHIP_URL = "organization/packages/purchase-package-sponsership"
const API_PURCHASE_ORGANIZATION_TOP_LISTING_SUBSCRIPTION_PLAN_URL = "organization/organization-top-listing-subscription-plans/purchase-plan"

export const getOffer = (dataToBeSent) => {
  return axiosInstance.get(`${GET_ALL_OFFER}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};

export const createOffer = (offerBody) => {
  return axiosInstance.post(CREATE_OFFER, offerBody);
};

export const updateOffer = (offerBody) => {
  return axiosInstance.patch(EDIT_OFFER + "/" + offerBody?._id, offerBody);
};

export const getOfferById = (offerBody) => {
  return axiosInstance.get(GET_OFFER_BY_ID + "/" + offerBody?.selectedOfferId);
};

export const deleteOfferById = (offerBody) => {
  return axiosInstance.patch(DELETE_OFFER + "/" + offerBody?.selectedOfferId, {
    is_active: false,
  });
};

export const purchaseOfferSponsorship = (dataToBeSent) => {
  return axiosInstance.post(API_PURCHASE_OFFER_SPONSORSHIP_URL, dataToBeSent);
};

export const purchasePackageSponsorship = (dataToBeSent) => {
  return axiosInstance.post(API_PURCHASE_PACKAGE_SPONSORSHIP_URL, dataToBeSent);
};

export const purchaseOrganizationTopListingSubscriptionPlan = (dataToBeSent) => {
  return axiosInstance.post(API_PURCHASE_ORGANIZATION_TOP_LISTING_SUBSCRIPTION_PLAN_URL, dataToBeSent);
};
